export default __webpack_public_path__ + "static/media/Agent-man.cbf00ad2.jpg";